export const LINKTONE_TYPES = {
  single: { id: 'single', name: 'לינקטון רגיל', trackLimit: 1, price: 1320, blurb: 'רצועה אחת — אידיאלי לסינגל', icon: 'disc' },
  ep: { id: 'ep', name: 'לינקטון EP', trackLimit: 6, price: 1950, blurb: 'עד 6 רצועות — מושלם ל־EP', icon: 'music' },
  album: { id: 'album', name: 'לינקטון אלבום', trackLimit: 14, price: 2250, blurb: 'עד 14 רצועות — לאלבום מלא', icon: 'album' },
};

export const STATUS_META = {
  draft: { label: 'טיוטה', klass: 'draft' },
  ready: { label: 'מוכן לשליחה', klass: 'ready' },
  pay: { label: 'ממתין לתשלום', klass: 'pay' },
  review: { label: 'נשלח לאישור', klass: 'review' },
  published: { label: 'פורסם', klass: 'published' },
};

export const WIZARD_STEPS = [
  { key: 'details', label: 'פרטי לינקטון', hint: 'שם וסוג' },
  { key: 'images', label: 'תמונות', hint: 'ראשית וגלריה' },
  { key: 'video', label: 'וידאו', hint: 'קליפ YouTube' },
  { key: 'comms', label: 'תקשורת', hint: 'קומוניקט ומילים' },
  { key: 'tracks', label: 'רצועות', hint: 'אודיו ופרטים' },
  { key: 'review', label: 'סיכום', hint: 'בדיקה לפני שליחה' },
  { key: 'terms', label: 'אישור ושליחה', hint: 'תנאים וחיוב' },
];

export function emptyForm(typeId, artistName) {
  return {
    name: 'לינקטון חדש',
    type: typeId,
    artist: artistName || '',
    overrideArtistName: '',
    label: [],
    releaseDate: '',
    images: { main: null, catalog: null, email: null, gallery: [] },
    youtube: '',
    comms: { pressReleasePdf: null, pressReleaseDoc: null, lyrics: null, credits: null, creditsText: '', stickerText: '' },
    tracks: [],
    agreed: false,
  };
}

export function getSampleLinktones(artistName) {
  const artist = artistName || 'נועם אדם';
  return [
    { id: 1, name: 'שמש באמצע', artist, type: 'single', tracks: 0, status: 'draft', paymentMode: 'none', lastEdited: 'לפני 2 ימים' },
    { id: 2, name: 'לילה לבן', artist, type: 'ep', tracks: 6, status: 'ready', paymentMode: 'none', lastEdited: 'אתמול' },
    { id: 3, name: 'געגוע אחרון', artist, type: 'single', tracks: 1, status: 'pay', paymentMode: 'none', lastEdited: 'לפני 4 ימים' },
    { id: 4, name: 'פעמיים בשבוע', artist, type: 'ep', tracks: 4, status: 'review', paymentMode: 'paid', lastEdited: 'לפני שבוע' },
    { id: 5, name: 'מילים שלא נאמרו', artist, type: 'album', tracks: 11, status: 'published', paymentMode: 'balance', lastEdited: 'לפני חודש' },
  ];
}
